import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import RedeemModallStore from './store';
import { getLocales } from '@src/global-locales/get-page-locales-data';

const styles = require('./index.less');
/**
 * 弹窗模板, 可以快速套用修改
 * @param {RemmedModalStore} store
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const RedeemModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen} hideMask>
      <div className={cx(styles.remmedModalModalRoot, store.isActive && styles.remmedModalModalRootAct)}>
        <div className={styles.mask} />
        <div className={styles.content}>
          <div className={styles.headTitle}>{store.modalTitle}</div>
          <div className={styles.cdkeyContentBox}>
            <div className={styles.keyNumber}>{store.cdKey}</div>
            <div className={styles.copyBtn} onClick={store.copyCdKey}>
              <div className={styles.normal} />
              <div className={styles.hover} />
              <span>{getLocales('gift.copy_btn_text')}</span>
            </div>
          </div>
          <div className={styles.tipsContentBox}>
            <div>{getLocales('gift.pickUp_location_tips_text')}</div>
            <div>{getLocales('gift.claim_limit_tips_text')}</div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(RedeemModal, RedeemModallStore);
